import React from "react";
import { FormField } from "./PublicFormControls";
import YesNoOptions, { isYesNoField } from "./YesNoOptions";
import "./RegistrationForm.css";

const CORE = new Set(["name", "gender", "email", "date_of_birth", "age", "phone", "registration_number"]);

export default function RegistrationQuestions({ definition, values, onChange, omitInitialHeading = false }) {
  const fields = Object.fromEntries((definition?.fields || []).map((field) => [field.key, field]));
  const blocks = definition?.blocks || [];
  const medicalFieldIndexes = new Set();
  let inMedicalSection = false;
  blocks.forEach((block, index) => {
    if (block.type === "heading") inMedicalSection = block.text.trim().toLowerCase() === "medical history";
    else if (inMedicalSection && block.type === "field") medicalFieldIndexes.add(index);
  });
  const renderField = (fieldKey, medical = false) => {
    if (CORE.has(fieldKey)) return null;
    const field = fields[fieldKey];
    if (!field) return null;
    if (isYesNoField(field)) return <YesNoOptions key={field.key} field={field} value={values[field.key]}
      onChange={onChange} checkboxStyle={medical} />;
    return <FormField key={field.key} field={field} value={values[field.key]} onChange={onChange} compact />;
  };
  return <div className="registration-questions">
    {blocks.map((block, index) => {
      if (omitInitialHeading && index === 0 && block.type === "heading"
        && block.text.trim().toLowerCase() !== "medical history") return null;
      if (block.type === "heading") {
        const medical = block.text.trim().toLowerCase() === "medical history";
        if (medical) {
          const questions = [];
          let nextIndex = index + 1;
          while (medicalFieldIndexes.has(nextIndex)) {
            const field = fields[blocks[nextIndex].field_key];
            if (field && !CORE.has(field.key)) questions.push(renderField(field.key, true));
            nextIndex += 1;
          }
          const middle = Math.ceil(questions.length / 2);
          const columns = [questions.slice(0, middle), questions.slice(middle)];
          return <section key={`medical-${index}`} className="registration-medical-section">
            <h3 className="registration-section-heading">{block.text}</h3>
            <div className="registration-medical-grid">{columns.map((column, columnIndex) => <div
              key={`medical-column-${columnIndex}`}
              className={`registration-medical-column${columnIndex === 1 ? " registration-medical-column-divider" : ""}`}>
              <div className="registration-medical-column-heading"><span />
                <span className="registration-medical-answer-heading">Yes</span>
                <span className="registration-medical-answer-heading">No</span>
              </div>
              {column}
            </div>)}</div>
          </section>;
        }
        return <h3 key={`heading-${index}`} className="registration-section-heading">{block.text}</h3>;
      }
      if (block.type !== "field" || CORE.has(block.field_key)) return null;
      if (medicalFieldIndexes.has(index)) return null;
      return renderField(block.field_key);
    })}
  </div>;
}
